import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import ResetPasswordPage from "./pages/ResetPasswordPage"
import { SignupPage } from "./pages/SignupPage"
import { LoginPage } from "./pages/LoginPage"
import { SignupSuccessPage } from "./pages/SignupSuccessPage"
import { InviteUserPage } from "./pages/InviteUserPage"
import { SignupByInvitePage } from "./pages/SignupByInvitePage"

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/signup",
    element: <SignupPage />,
  },
  {
    path: "/signup-by-invite",
    element: <SignupByInvitePage />,
  },
  {
    path: "/signup-success",
    element: <SignupSuccessPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/invite",
    element: <InviteUserPage />,
  },
  // {
  //   path: "demo/:canvasId/:cloudflareEnv",
  //   element: <DemoPage />,
  // },
  {
    path: "reset-password",
    element: <ResetPasswordPage />,
  },
])

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(<RouterProvider router={router} />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
